<template>
  <v-dialog v-model="internalDialog" max-width="500px" persistent>
    <v-card>
      <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="handleResponse(true)">
        <v-card-title class="headline">
          <v-icon color="blue-grey" class="mr-2">mdi-printer</v-icon>
          Imprimir Remito ASN
        </v-card-title>

        <v-card-text class="pt-4">
          <p class="text-body-1 mb-4">
            Este ASN contiene <strong>{{ imageCount }}</strong> imagen(es) de recepción.
          </p>
          <p class="text-body-2 text-grey-darken-1">
            ¿Desea incluir las imágenes en el PDF? Las imágenes se agregarán en hojas adicionales al final del documento.
          </p>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn 
            color="grey" 
            variant="text" 
            @click="handleResponse(false)"
            :disabled="loading"
          >
            Sin imágenes
          </v-btn>
          <v-btn 
            color="success" 
            variant="text" 
            type="submit"
            :loading="loading"
            class="px-6"
          >
            Con imágenes
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modelValue: Boolean,
    imageCount: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "confirm"],
  data() {
    return {
      valid: false
    };
  },
  computed: {
    internalDialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    modelValue(val) {
      if (val && this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  methods: {
    handleResponse(includeImages) {
      this.$emit("confirm", includeImages);
    }
  }
};
</script>

<style scoped>
.headline {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
</style>
